module.exports = __webpack_public_path__ + "static/media/receta-09.c446e12b.png";